import React, { useState } from 'react';
import { Button, Grid, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { invoiceCancelStatuses } from "../../../../constants/securspace-constants";
import Busy from "../../../../Busy";
import { requestPatchInvoiceStatus } from "../../../request/invoiceRequests";
import { CallbackActions } from "../../../../../util/ActionUtils";
import {getErrorMessage} from "../../../../../util/NetworkErrorUtil";

interface CancelInvoiceOption {
  label: string;
  status: string;
  requireExplanation: boolean;
}

const CancelInvoiceOptions: CancelInvoiceOption[] = [
  {
    label: 'Uncollectible',
    status: invoiceCancelStatuses.UNCOLLECTIBLE,
    requireExplanation: false,
  },
  {
    label: 'Cancel - Term Changes',
    status: invoiceCancelStatuses.CANCEL_TERM_CHANGES,
    requireExplanation: false,
  },
  {
    label: 'Cancel - Booking Cancelled',
    status: invoiceCancelStatuses.CANCEL_BOOKING_CANCELLED,
    requireExplanation: false,
  },
  {
    label: 'Cancel - Billing Requirements',
    status: invoiceCancelStatuses.CANCEL_BILLING_REQUIREMENTS,
    requireExplanation: false,
  },
  {
    label: 'Cancel - Other',
    status: invoiceCancelStatuses.CANCEL_OTHER,
    requireExplanation: true,
  },
];

interface CancelInvoiceModalProps {
  invoice: { transactionId: string; transactionNumber: string | number };
  open: boolean;
  onInvoiceAction: (callbackAction?: string, invoice?: { transactionId: string }, message?: string) => void;
  onClose: (callbackAction?: string, invoice?: { transactionId: string }, message?: string) => void;
}

const CancelInvoiceModal = (props: CancelInvoiceModalProps) => {
  const { invoice, open, onInvoiceAction, onClose } = props;
  const [cancelStatus, setCancelStatus] = useState('');

  const handleClose = () => {
    onClose();
  };

  const onRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const index = parseInt(event.target.value);
    setCancelStatus(CancelInvoiceOptions[index].status);
  }

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const index = parseInt(formData.get('refundRequestResponse') as string);
    const status = CancelInvoiceOptions[index].status;

    const payload = { status, statusNotes: formData.get('reason') as string };

    const successCancelInvoice = () => {
      Busy.set(false);
      onClose(CallbackActions.SUCCESS, invoice, `Successfully cancelled invoice ${invoice.transactionNumber}`);
    };
    const failCancelInvoice = (error: unknown) => {
      Busy.set(false);
      onInvoiceAction(CallbackActions.ERROR, invoice, getErrorMessage(error));
    };

    Busy.set(true);
    requestPatchInvoiceStatus(invoice.transactionId, payload, successCancelInvoice, failCancelInvoice);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: 'form',
        onSubmit
      }}
    >
      <DialogTitle>
        Respond to Cancel Request
      </DialogTitle>
      <DialogContent>
        <RadioGroup
          name={"refundRequestResponse"}
          onChange={onRadioChange}
        >
          {CancelInvoiceOptions.map((cancelInvoiceOption, index) => {
            return <FormControlLabel
              key={cancelInvoiceOption.label}
              value={index}
              label={cancelInvoiceOption.label}
              control={<Radio />}
            />
          })}
        </RadioGroup>
        <DialogContentText>
          Please provide an explanation for the cancellation
        </DialogContentText>
        <TextField
          required
          margin="dense"
          id="outlined-multiline-static"
          name="reason"
          label="Reason for Cancellation"
          helperText="Enter the reason this invoice is being cancelled."
          multiline
          rows={2}
          fullWidth
          variant="standard"
        />

      </DialogContent>
      <DialogActions>
        <Grid container justifyContent={"center"}>
          <Button variant="text" onClick={handleClose} >Cancel</Button>
          {cancelStatus && <Button variant="contained" type="submit" >Cancel Invoice</Button>}
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
export default CancelInvoiceModal;
